import {
    getDirectoryTypeName, toDirectoryDTO,
} from '../directory-integration.functions';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, DirectoriesResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.name = '';
        this.directoryTypeName = getDirectoryTypeName(this.directoryType); 
    }

    save() {
        this.isSaving = true;
        this.DirectoriesResource
            .createDirectory(this.companyId, this.name, this.directoryType, this.tenantId)
            .then((directory) => {
                directory = toDirectoryDTO(directory)
                this.directories.push(directory);
                this.Alert('success', 'company.directory-integration.add-directory.added',
                    {directoryTypeName: this.directoryTypeName});
                if (directory.isAzure) {
                    return this.$state.go('company.directory-integration.manage.connection-azure', {directoryId: directory.id});
                } else if (directory.isSCIM) {
                    return this.$state.go('company.directory-integration.manage.connection-scim', {directoryId: directory.id});
                } else {
                    return this.$state.go('company.directory-integration.manage.domains', {directoryId: directory.id});
                }
            })
            .finally(() => this.isSaving = false)
    }

    requiresTenantId() {
        return this.directoryType == 'AZURE' || this.directoryType == 'SCIM';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/add/add-directory.controller.js